module.exports = __webpack_public_path__ + "img/进行中.716b0926.png";